import React from "react";
import { ArrowRight } from "lucide-react";

export default function MessageCard({ email, message, date }) {
  return (
    <div className="mt-10 shadow-2xl rounded-3xl px-6 py-4 mx-2">
      <div className="flex gap-4 mb-4">
        <div className="bg-gray-200 shadow-xl size-10 rounded-full"></div>
        <div>
          <p className="font-bold">{email}</p>
          <p className="text-gray-600">{message}</p>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-[#868686]">{date}</p>
        <button className="bg-black items-center gap-2 px-4 py-2 flex text-white font-bold rounded-3xl">
          Read <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
}